
import { Sale, SaleType } from "@/models/base";
import { SaleEditState } from "@/utils/sale-edit/sale-edit-state";
import { printLocalDate } from "@/utils/pretty-print";
import Vue from "vue";
import { ToolbarService } from "../../services/toolbar-service";
import AppSaleEditDesktop from "./SaleEditDesktop.vue";
import AppSaleEditMobile from "./SaleEditMobile.vue";
import { AuthService } from "@/services/auth-service";
import { UpgradeService } from "@/services/upgrade-service";
import {ScannerListener} from "@/utils/scanner";
import AppLoadDepositsModal from "./LoadDepositsModal.vue";
import AppCreatedDepositsCreateBank from "./SaleEditCreatedDepositsCreateBank.vue";
import AppCarpassInputModal from "../cars/CarpassInputModal.vue";
import AppCarSelectModal from "./CarSelectModal.vue";
import AppSaleEditContactExtraInfoEdit from "./SaleEditContactExtraInfoEdit.vue";
import AppProcessingMessageModal from "./ProcessingMessageModal.vue";
import AppSaleRowsFromCsvModal from "./SaleRowsFromCsvModal.vue";
import AppSaleEditRowExtraFields from "./SaleEditRowExtraFields.vue";
import AppSaleEditProductsWithNotEnoughInStockGroupSelect from "./SaleEditProductsWithNotEnoughInStockGroupSelect.vue";
import AppCreateCalendarEventModal from "./CreateCalendarEventModal.vue";
import AppSaleEditSortRowsModal from "./SaleEditSortRowsModal.vue";
import AppEditProduct from "@/components/products/ProductEditCard.vue";

export default Vue.extend({
	data() {
		return {
			state: new SaleEditState(this, this.contactGroupId)
		};
	},
	props: {
		value: {
			required: true,
			type: Object as () => Sale
		},
		isSubscription: Boolean,
		contactGroupId: {
			type: Number,
			required: true
		},
		preventRedirect: Boolean,
	},
	computed: {
		tag():string{
			if (this.state.shouldUseMobileLayout){
				return "app-sale-edit-mobile";
			}
			return "app-sale-edit-desktop";
		}
	},
	watch: {
		value: {
			deep: false,
			immediate: true,
			handler(s:Sale) {
				this.state.setSale(s);
				this.updateTitle();
			}
		},
		"state.sale.ID"() {
			this.updateTitle();
		},
		"state.sale.Type"(currentType:SaleType, prevType:SaleType) {
			this.updateTitle();
			this.state.getSaleConfig();
			if (this.state.sale.Contact == null) return;
			if (currentType == null) return;
			if (currentType.ContactGroupID != this.state.sale.Contact.GroupID){
				this.state.sale.Contact == null;
			}
		},
		"$i18n.locale"() {
			this.updateTitle();
		},
	},
	methods: {
		updateTitle() {
			if (this.state.sale.Type) {
				//let typeName = this.state.sale.Type.Name.getTranslation(this.$i18n.locale);
				let locale = this.$i18n.locale;
				let typeName = this.state.sale.Type.getDisplayedName(locale);
				ToolbarService.title = this.$ct(this.state.sale.ID ? "title-purchase-edit" : "title-purchase-add",
					{type: typeName,id: this.state.sale.ComputedFriendlyID,date: printLocalDate(this.state.sale.InvoiceDate)}).toString();
			}
		},
		onScannerInput(input:string){
			this.state.onScannerInput(input);
		}
	},
	async created() {
		let r = await AuthService.hasRemainingSales();
		if(this.state.sale.ID == 0 && !r){
			await UpgradeService.showUpgradeModal(0);
		}
		this.state.vue = this;
		this.state.preventRedirect = this.preventRedirect;
		this.state.on("saved", (s:Sale) => this.$emit("input", s));
		this.state.on("close", () => this.$emit("close"));
		ScannerListener.onInput(this.onScannerInput);
		if(this.value.ContactID && !this.value.Contact){
			if(this.state){
				let c = await this.state.getContactService().getContact(this.value.ContactID);
				this.value.ContactID = 0;
				await this.state.selectContact(c);
			}
		}
	},
	async mounted(){
		this.$emit("state",this.state);
	},
	destroyed(){
		ScannerListener.offInput(this.onScannerInput);
		this.state.deInit();
	},
	components: {
		AppSaleEditDesktop,
		AppSaleEditMobile,
		AppLoadDepositsModal,
		AppCreatedDepositsCreateBank,
		AppCarSelectModal,
		AppCarpassInputModal,
		AppProcessingMessageModal,
		AppSaleEditContactExtraInfoEdit,
		AppCreateCalendarEventModal,
		AppSaleEditProductsWithNotEnoughInStockGroupSelect,
		AppSaleRowsFromCsvModal,
		AppSaleEditRowExtraFields,
		AppEditProduct,
		AppSaleEditSortRowsModal
	},
	i18nEx: {
		componentPrefix: "components.sales"
	}
});
